/**
 * Marquee Component
 * Scrolling text banner - matches Elementor ucaddon_list_marquee styling
 * Infinite loop with pause on hover
 */

'use client'

import { cn } from '@/lib/utils'

interface MarqueeProps {
	items: string[]
	speed?: number
	pauseOnHover?: boolean
	className?: string
}

export function Marquee({
	items,
	speed = 30,
	pauseOnHover = true,
	className,
}: MarqueeProps) {
	// Duplicate items multiple times for seamless infinite loop
	const duplicatedItems = [...items, ...items, ...items, ...items]

	return (
		<div
			className={cn(
				'relative flex items-center overflow-hidden bg-[#CDFF00] py-0 px-0',
				pauseOnHover && 'group',
				className
			)}
		>
			<div
				className={cn(
					'flex animate-marquee-infinite',
					pauseOnHover && 'group-hover:paused'
				)}
				style={{
					animationDuration: `${speed}s`,
				}}
			>
				{duplicatedItems.map((item, index) => (
					<div
						key={index}
						className='shrink-0 whitespace-nowrap text-center px-5 py-2.5 mx-0 my-2.5 border-l-2 border-[#09194D]'
					>
						<span className='text-[#09194D] font-["Bricolage_Grotesque"] text-base font-bold'>
							{item}
						</span>
					</div>
				))}
			</div>
		</div>
	)
}
